import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

/** Sync header keyword search with the active listing browse page. */
@Injectable({providedIn: 'root'})
export class BrowseKeywordService {
  private readonly applied$ = new Subject<string>();

  readonly applied = this.applied$.asObservable();

  apply(keyword: string): void {
    this.applied$.next(keyword ?? '');
  }
}
